import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { OrderReceiptResponse } from '@models/order';
import { useTranslation } from 'react-i18next';

import ReceiptDivider from '../ReceiptDivider';

interface Props {
    receipt: OrderReceiptResponse;
}

function Amount({ receipt }:Props) {
    const { t } = useTranslation('orderReceipt');
    const { order } = receipt;
    const {
        paymentAmount, totalAmount, couponDiscount, vatAmount,
    } = order;
    return (<Column fullWidth>
        <Column fullWidth spacing={2}>
            <Row fullWidth justify='space-between'>
                <Text>{t('amount.total')}</Text>
                <Text>{totalAmount.toLocaleString()}</Text>
            </Row>
            {(couponDiscount !== 0) && (
                <Row fullWidth justify='space-between'>
                    <Text>{t('amount.coupon')}</Text>
                    <Text>{couponDiscount.toLocaleString()}</Text>
                </Row>
            )}
        </Column>
        <ReceiptDivider/>
        <Column spacing={2} fullWidth>
            <Row fullWidth justify='space-between'>
                <Text size='2xl' fontWeight='bold'>{t('amount.paymentAmount')}</Text>
                <Text size='2xl' fontWeight='bold'>
                    {paymentAmount.toLocaleString()}
                </Text>
            </Row>
            <Row fullWidth justify='space-between'>
                <Text size='lg'>{t('amount.vatIncluded')}</Text>
                <Text size='lg'>{vatAmount.toLocaleString()}</Text>
            </Row>
        </Column>
        <ReceiptDivider/>
    </Column>);
}

export default Amount;
